// src/modules/app-views/goodsReceipt/pages/Document/modals/InstallmentModal/Step1.jsx
// *******************************************************************************
// INSTALLMENT MODAL - STEP 1
// *******************************************************************************
// Form fields for adding/editing a payment installment (duplicata).
// Fields: installment number, due date, amount, payment type code.
// *******************************************************************************

// *******************************************************************************
// IMPORTS
// *******************************************************************************
import { useMemo } from 'react';
import { Row, Col } from 'antd';
import SimpleInput from 'components/SimpleComponents/SimpleInput';
import SimpleDatePicker from 'components/SimpleComponents/SimpleDatePicker';
import SimpleCurrency from 'components/SimpleComponents/SimpleCurrency';
import SimpleSelect from 'components/SimpleComponents/SimpleSelect';
import translateX from 'utils/translateX';
import fiscalService from 'services/fiscalService';

// *******************************************************************************
// STEP COMPONENT
// *******************************************************************************
const Step1 = () => {
  // ─────────────────────────────────────────────────────────────────────────────
  // 7. LOCAL VARIABLES II
  // ─────────────────────────────────────────────────────────────────────────────
  const paymentTypeOptions = useMemo(() => buildPaymentTypeOptions(), []);

  // ─────────────────────────────────────────────────────────────────────────────
  // 8. UI
  // ─────────────────────────────────────────────────────────────────────────────
  return (
    <Row gutter={[16, 0]}>
      <Col xs={24} md={8}>
        <SimpleInput
          name="number"
          label="installment_number"
          placeholder="001"
          required
        />
      </Col>

      <Col xs={24} md={8}>
        <SimpleDatePicker
          name="dueDate"
          label="due_date"
          required
        />
      </Col>

      <Col xs={24} md={8}>
        <SimpleCurrency
          name="amount"
          label="amount"
          min={0.01}
          required
          currencies={[{ value: 'BRL', label: 'R$' }]}
        />
      </Col>

      <Col xs={24}>
        <SimpleSelect
          name="type"
          label="payment_method"
          options={paymentTypeOptions}
          showSearch
          placeholder="select_payment_method"
        />
      </Col>
    </Row>
  );
};

// *******************************************************************************
// EXPORT
// *******************************************************************************
export default Step1;

// *******************************************************************************
// HELPERS
// *******************************************************************************

/**
 * Build payment type options from fiscalService constants
 */
function buildPaymentTypeOptions() {
  return Object.entries(fiscalService.PAYMENT_TYPES).map(([, value]) => ({
    value: value.code,
    label: translateX(value.labelKey),
  }));
}
